import { RouteConfig } from "vue-router";

const contratos: RouteConfig = {
  path: "/contratos",
  name: "contratos",
  component: () => import(/* webpackChunkName: "contratos" */ "@/views/Contratos.vue"),
};

export default contratos;
